<template>
  <v-select
    ref="category"
    v-model="category"
    v-bind="$attrs"
    v-on="$listeners"
    item-text="title"
    item-value="id"
    :label="$t('finance.category')"
    :loading="loading"
    :items="items"
    :disabled="!typeId"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    typeId: {
      default: '',
    },
  },
  data: () => ({
    loading: false,
  }),
  watch: {
    typeId: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue) return;
        if (oldValue) {
          this.$refs.category.reset();
        }

        this.fetchCategories('');
      },
    },
  },
  computed: {
    category: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
    items() {
      return this.$store.state['company-expenses'].categoriesList;
    },
  },
  methods: {
    async fetchCategories(title) {
      if (!this.typeId) return;

      this.loading = true;
      await this.$store.dispatch('company-expenses/fetchCategories', {
        typeId: this.typeId,
        title,
      });
      this.loading = false;
    },
  },
};
</script>

<style></style>
